import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/default/header";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";
import SingleLeadData from "./singLeadData";
import GlobalSidebarMenu from "../../default/header/globalSidebarMenu";


const SingleLead = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>Update Lead</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                 <GlobalSidebarMenu sidebarTitle="" />
                <div className="content-right">
                    <Breadcrumb />
                    <SingleLeadData />
                </div>
            </div>
        </div>
        
    );
}

export default SingleLead;
